export default "__VITE_ASSET__D3RpwVh3__"